

import axios from "axios";
import { loginDestination } from "./utils/notificationReturn";

export const NodeAPI = axios.create({
  baseURL: process.env.REACT_APP_NODE_API_BASE_URL || "/api/node"
});

// 🔐 REQUEST INTERCEPTOR: Attach token and user ID
NodeAPI.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");

  if (token) req.headers.Authorization = `Bearer ${token}`;
  if (userId) req.headers["x-user-id"] = userId;
req.headers["Content-Type"] = "application/json";  // add this line
  return req;
}, (error) => {
  return Promise.reject(error);
});

// ❌ RESPONSE INTERCEPTOR: Handle 401 Unauthorized
NodeAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear session and redirect to login
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      window.location.href = loginDestination(window.location.pathname); // Preserve a safe daily-session return path
    }
    return Promise.reject(error);
  }
);



export const FlaskAPI = axios.create({
  baseURL: process.env.REACT_APP_FLASK_API_BASE_URL || "/api/python"
});

export default NodeAPI;
